module.exports = __webpack_public_path__ + "static/how-it-works-5860cd9b71e0f454214aafb8a749a9af.png";